// src/components/ui/atoms/WarningBanner.tsx
import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import type {
  WarningType,
  WarningReason,
} from '../../../../utils/computeWarning';

interface WarningBannerProps {
  type: WarningType;
  reasons: WarningReason[];
}

const WarningBanner: React.FC<WarningBannerProps> = ({ type, reasons }) => {
  const isAllergy = type === 'allergy' || type === 'mixed';

  const iconColor = isAllergy ? 'text-red-600' : 'text-orange-500';
  const borderColor = isAllergy
    ? 'border-red-600 bg-red-50 text-red-800'
    : 'border-orange-500 bg-orange-50 text-orange-800';

  const message =
    type === 'mixed'
      ? 'Contains items you chose to avoid:'
      : type === 'allergy'
        ? 'Contains ingredients you’re allergic to'
        : 'Contains items you chose to avoid';

  return (
    <div
      className={`mx-4 mt-4 rounded border-l-4 px-4 py-2 flex items-start gap-3 ${borderColor}`}
    >
      <FaExclamationTriangle className={`w-5 h-5 ${iconColor}`} />
      <div className="flex-1">
        <p className="font-medium text-xs whitespace-nowrap truncate">
          {message}
        </p>
        <ul className="list-disc list-inside mt-1 text-xs space-y-0.5">
          {reasons.map((r) => (
            <li
              key={`${r.name}-${r.type}-${r.warningType}`}
              className="truncate"
            >
              {r.type === 'tag' && r.category
                ? `${capitalize(r.category)}: ${r.name}`
                : r.warningType === 'allergy'
                  ? `Allergy: ${r.name}`
                  : `Avoid: ${r.name}`}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default WarningBanner;
